import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const buildQuery = (params = {}) => {
  const query = new URLSearchParams();

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      query.set(key, value);
    }
  });

  return query.toString();
};

const homeProducts = createApi({
  reducerPath: "homeProducts",
  baseQuery: fetchBaseQuery({
    baseUrl: "/api/",
  }),
  endpoints: (builder) => ({
    filterProducts: builder.query({
      query: (params = {}) => ({
        url: `products-filter?${buildQuery(params)}`,
        method: "GET",
      }),
    }),

    allBrands: builder.query({
      query: () => ({
        url: "allbrands",
        method: "GET",
      }),
    }),

    allCategories: builder.query({
      query: () => ({
        url: "allcategories",
        method: "GET",
      }),
    }),

    homepageSectionProducts: builder.query({
      query: ({ type, limit = 8, ids = [] }) => {
        const params = new URLSearchParams();

        params.set("limit", limit);

        if (ids?.length) {
          params.set("ids", ids.join(","));
        }

        return {
          url: `homepage/products/${type}?${params.toString()}`,
          method: "GET",
        };
      },
    }),
  }),
});

export const {
  useFilterProductsQuery,
  useLazyFilterProductsQuery,
  useAllBrandsQuery,
  useAllCategoriesQuery,
  useHomepageSectionProductsQuery,
} = homeProducts;

export default homeProducts;
